import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { getFacilityCategoryLabel, type HaNFacilityCategory, type HaNTextRange } from "@lib/logic";
import { ModalCellItemIcon } from "@molecules";

import { HaNSearchResultCell } from "./HaNSearchResultCell";

type CategorySearchResultProps = {
  category: HaNFacilityCategory;
  ranges: HaNTextRange[];
  count: number;
};

const getIconProps = (category: HaNFacilityCategory) => {
  switch (category.kind) {
    case "area":
      return { icon: "desk" } as const;
    case "room":
      return { icon: "meetingRoom" } as const;
    case "facility":
      return { icon: "toilet", iconUrl: category.facilityType.lightIconUrl || undefined } as const;
  }
};

export const CategorySearchResult = ({ category, ranges, count }: CategorySearchResultProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <HaNSearchResultCell
      icon={
        <ModalCellItemIcon
          className="flex-none"
          backgroundColor={theme.card.beige500.background}
          {...getIconProps(category)}
        />
      }
      name={getFacilityCategoryLabel(category, t)}
      ranges={ranges}
      details={t("hereAndNow:ResultCount", { count })}
    />
  );
};
